// Add the pattern and the yarns selected to the cart
document.addEventListener('DOMContentLoaded', function() {
  const addbuttons = document.getElementsByClassName('add-to-cart-form--submit-kit');

  for (let i = 0; i < addbuttons.length; i++) {
    addbuttons[i].addEventListener('click', function() {
      var kitSizeElement = this.closest('.kit-size');
      var patternVariant = kitSizeElement.dataset.pattern_variant_id;
      var sizeId = kitSizeElement.dataset.size_id;
      console.log('AddYarnAndPattern', 'patternVariant', patternVariant, 'sizeId', sizeId);
      const xhr = new XMLHttpRequest();
      xhr.open("POST", "/cart/add.js", false);
      xhr.setRequestHeader("Content-Type", "application/json");
      xhr.onload = function () {
        if (xhr.status === 200) {
          //console.log('Success');
          window.location.href = "/cart";
        } else {
          console.error("Error:", xhr.status);
        }
      };
      let formData = {
        items: [],
      };
      // Get the size we are adding.
      var size = document.getElementById(sizeId);
      // Get all the yarns and quantities for this size.
      var yarns = size.getElementsByClassName("kit-yarn");
      // Add the yarns in reverse order so that they appear in the cart in the same order they were
      // displayed on this kit screen.
      for (let i = yarns.length-1; i >= 0; i--) {
        var yarn = yarns[i];
        var variant = yarn.dataset.variant_id;
        var quantityElem = yarn.getElementsByClassName("kit-yarn-qty")[0];
        var quantity = quantityElem.getElementsByClassName("quantity-selector--input")[0].value;
        formData.items.push({
          id: variant,
          quantity: quantity,
        });
      }
      if (patternVariant > 0) {
        formData.items.push({
          id: patternVariant,
          quantity: 1,
        });
      }
      let data = JSON.stringify(formData);
      console.log(data);
      xhr.send(data);
    });
  }
});

// Toggle between the version sizes.
document.addEventListener('DOMContentLoaded', function() {
  const collapsibles = document.getElementsByClassName('kit-version-size-selector');

  for (let i = 0; i < collapsibles.length; i++) {
    collapsibles[i].addEventListener('click', function() {

      // Get the version size we should display.
      var radio = this.querySelector("input[type='radio']");
      var size_id = radio.value;
      radio.checked = true;
      
      const sizes = document.getElementsByClassName('kit-size');
      for (let i = 0; i < sizes.length; i++) {
        var size = sizes[i];
        if (size.dataset.size_id == size_id) {
          size.style.display = 'block';
        } else {
          size.style.display = 'none';
        }
      }
    });
  }
});

// Set up the popup selectors.
document.addEventListener('DOMContentLoaded', function() {
  var modals = document.getElementsByClassName("kit-popup-selector");
  
  // When the user clicks the button, open the modal 
  var btns = document.getElementsByClassName("kit-yarn-popup-selector-button");
  for (var i=0; i<btns.length; i++) {
    var btn = btns[i];
    btn.onclick = function() {
      var kitYarn = this.closest('.kit-yarn');
      var yarn = kitYarn.dataset.yarn;
      var yarnId = kitYarn.dataset.yarn_id;
      var modal = document.getElementById("kit-popup-selector-" + yarn);
      modal.dataset.yarn_id = yarnId;
      modal.style.display = "block";
    }
  }
  
  // When the user clicks on <span> (x), close the modal
  var spans = document.getElementsByClassName("kit-popup-selector-close");
  for (var i=0; i<spans.length; i++) {
    var span = spans[i];
    span.onclick = function() {
      for (var i=0; i<modals.length; i++) {
        var modal = modals[i];
        modal.style.display = "none";
      }
    }
  }
  
  // When the user clicks anywhere outside of the modal, close it
  window.onclick = function(event) {
    for (var i=0; i<modals.length; i++) {
      var modal = modals[i];
      if (event.target == modal) {
          modal.style.display = "none";
      }
    }
  }
  
  // Function to handle item selection
  var items = document.getElementsByClassName("kit-popup-selector-product");
  for (var i=0; i< items.length; i++) {
    var item = items[i];
    item.addEventListener('click', function() {
      var variant_id = this.dataset.variant_id;

      // Get the popup this item is in.
      var modal = this.closest(".kit-popup-selector");
      var yarnId = modal.dataset.yarn_id;

      // Get the kit yarn row we are changing.
      var yarnKit = document.querySelector(".kit-yarn[data-yarn_id='" + yarnId + "']");
      
      // Update the selection.
      yarnKit.dataset.variant_id = variant_id;
      yarnKit.dataset.variant_available = this.dataset.variant_available;

      // Update the name
      var thisName = this.querySelector(".product-thumbnail--title");
      var yarnName = yarnKit.querySelector(".product-thumbnail--title");
      yarnName.innerHTML = thisName.innerHTML;
      
      // Update the inventory. 
      var thisInv = this.querySelector(".product-thumbnail--inventory");
      var yarnInv = yarnKit.querySelector(".product-thumbnail--inventory");
      yarnInv.innerHTML = thisInv.innerHTML;
      
      // Update the lead time.
      var thisLead = this.querySelector(".product-thumbnail--leadtime");
      var yarnLead = yarnKit.querySelector(".product-thumbnail--leadtime");
      yarnLead.innerHTML = thisLead.innerHTML;
      
      // Update the image.
      var thisImg = this.querySelector(".product-thumbnail--image-container img");
      var yarnImg = yarnKit.querySelector(".product-thumbnail--image-container img");
      yarnImg.src = thisImg.src;
      yarnImg.alt = thisImg.alt;

      // Update the shown in a different base.
      var thisDiffBase = this.querySelector(".product-thumbnail--color-in-other-item");
      var yarnDiffBase = yarnKit.querySelector(".product-thumbnail--color-in-other-item");
      yarnDiffBase.innerHTML = thisDiffBase.innerHTML;

      // Update the link.
      var thisHref = this.dataset.product_href;
      var yarnHref = yarnKit.querySelector(".product-thumbnail");
      yarnHref.dataset.href = thisHref;

      // Determine if all the items are available for purchase.
      var size = yarnKit.closest(".kit-size");
      var available = true;
      var yarns = size.querySelectorAll(".kit-yarn");
      for (var i=0; i<yarns.length; i++) {
        if (!yarns[i].dataset.variant_available)
          available = false; 
      }
      var btn = size.querySelector(".add-to-cart-form--submit-kit");
      var btnAlt = size.querySelector(".add-to-cart-form--submit-kit-unavailable");
      if (available) {
        // Enable the button.
        btn.style.display = 'block';
        btnAlt.style.display = 'none';
      } else {
        // Disable the button.
        btn.style.display = 'none';
        btnAlt.style.display = 'block';
      }
            
      // Hide the modals.
      for (var i=0; i<modals.length; i++) {
        var modal = modals[i];
        modal.style.display = "none";
      }
    });
  }
  
});